import { memo } from 'react'
import { TextField } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { updateTargetContentSearchValue } from '@tabeeb/modules/sessionsPage/actions'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'

interface TargetContentSearchInputProps {
  contentSharingType: ContentSharingModelType
}

const TargetContentSearchInput: React.FC<TargetContentSearchInputProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const value = useSelector((state) => state.sessionsPage.targetContentSearchValue)

  const _onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTargetContentSearchValue({ searchQuery: e.target.value, contentSharingType }))
  }

  return (
    <TextField fullWidth value={value} onChange={_onSearch} placeholder='Search for session in destination tenant...' />
  )
}

export default memo(TargetContentSearchInput)

